import { useParams } from "react-router-dom";
import { useVolunteerData } from "../hooks/useVolunteerData";
import styles from "./PublicVolunteerDetail.module.scss";
import { CircularProgress, Alert, Chip } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import { SkillsInterestsList } from "../components/SkillsInterestsList/SkillsInterestsList";

export const PublicVolunteerDetail = () => {
  const { volunteerId } = useParams<{ volunteerId: string }>();
  const { data, loading, error } = useVolunteerData(volunteerId!);

  if (loading) {
    return (
      <div className={styles.container}>
        <div className={styles.centered}>
          <CircularProgress />
          <p>Načítání profilu dobrovolníka...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.container}>
        <div className={styles.centered}>
          <Alert severity="error">
            {error} Pro přístup k dalším informacím se prosím přihlaste.
          </Alert>
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className={styles.container}>
        <div className={styles.centered}>
          <Alert severity="warning">Dobrovolník nenalezen</Alert>
        </div>
      </div>
    );
  }

  const profileImage = 'profile_image' in data ? data.profile_image : undefined;

  return (
    <div className={styles.container}>
      <div className={styles.publicBadge}>
        <Chip 
          label="Veřejný profil uživatele"
          size="small"
        />
      </div>

      <div className={styles.header}>
        <div className={styles.avatar}>
          {profileImage ? (
            <img src={profileImage as string} alt={`${data.first_name} ${data.last_name}`} />
          ) : (
            <PersonIcon sx={{ fontSize: 80 }} />
          )}
        </div>
        <div className={styles.headerInfo}>
          <h1>
            {data.first_name} {data.last_name}
          </h1>
        </div>
      </div>

      <div className={styles.content}>
        {data.skills && data.skills.length > 0 && (
          <section className={styles.section || ''}>
            <SkillsInterestsList 
              items={data.skills} 
              type="skills" 
              title="Dovednosti" 
              emptyMessage="Dobrovolník nemá zadané žádné dovednosti."
            />
          </section>
        )}

        {data.interests && data.interests.length > 0 && (
          <section className={styles.section || ''}>
            <SkillsInterestsList 
              items={data.interests} 
              type="interests" 
              title="Zájmy" 
              emptyMessage="Dobrovolník nemá zadané žádné zájmy."
            />
          </section>
        )}

        <div className={styles.loginInfo}>
          <Alert severity="info">
            Pro zobrazení dalších informací o dobrovolníkovi se přihlaste.
          </Alert>
        </div>
      </div>
    </div>
  );
};

